<template>
  <div id="base-moment-date-picker-wrapper">
    <input
      autocomplete="off"
      :id="id"
      type="text"
      data-type="date"
      :name="name"
      :class="{ invalid: false }"
      :data-test-base-moment-date-picker="name"
      readonly="readonly"
    />
    <!-- class="{ invalid: errors.has(name) }" -->
  </div>
</template>

<script>
import Pikaday from 'pikaday';
import moment from 'moment';

export default {
  name: 'BaseMomentDatePicker',
  // inject: ['$validator'],
  props: {
    id: {
      type: String,
      default() {
        return 'base-moment-date-picker';
      }
    },
    name: {
      type: String,
      default() {
        return 'base-moment-date-picker';
      }
    },
    maxDate: {
      type: Object,
      default() {
        return null;
      }
    },
    minDate: {
      type: Object,
      default() {
        return null;
      }
    },
    modelValue: {
      type: [Object, null],
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      picker: null
    };
  },
  computed: {
    getDatePickerElement() {
      return document.querySelector('[name="' + this.name + '"]');
    },
    getFormattedi18nNames() {
      return {
        previousMonth: 'Forrige måned',
        nextMonth: 'Næste måned',
        months: [
          'januar',
          'februar',
          'marts',
          'april',
          'maj',
          'juni',
          'juli',
          'august',
          'september',
          'oktober',
          'november',
          'december'
        ],
        weekdays: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
        weekdaysShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør']
      };
    },
    getWrapperElement() {
      return document.querySelector('#base-moment-date-picker-wrapper');
    }
  },
  watch: {
    modelValue(val) {
      if (this.picker.getDate().toString() !== val.toDate().toString()) {
        this.picker.setDate(val.toDate(), false);
      }
    }
  },
  mounted() {
    this.picker = new Pikaday({
      container: this.getWrapperElement,
      defaultDate: this.modelValue,
      format: 'LL',
      field: this.getDatePickerElement,
      i18n: this.getFormattedi18nNames,
      firstDay: 1,
      setDefaultDate: this.modelValue !== null,
      yearRange: 15,
      onSelect: () => {
        this.$emit('update:modelValue', moment(this.picker.getDate()));
      },
      toString(date, format) {
        return moment(date).format(format);
      }
    });

    if (this.modelValue !== null) {
      this.picker.setDate(this.modelValue.toDate(), false);
    }

    if (this.minDate !== null) {
      this.picker.setMinDate(this.minDate.toDate());
    }

    if (this.maxDate !== null) {
      this.picker.setMaxDate(this.maxDate.toDate());
    }
  }
};
</script>

<style>
#claimDate, #base-moment-date-picker-wrapper [readonly] {
  cursor: text;
  background-color: white;
  color: black;
}

.pika-lendar .pika-title div {
  text-decoration: underline;
}

.lb .pika-lendar .pika-title div {
  color: #5692b5;
}

.bauta .pika-lendar .pika-title div {
  color: #68c398;
}

.runa .pika-lendar .pika-title div {
  color: #f16457;
}

.pfa .pika-lendar .pika-title div {
  color: #000562;
}
</style>
